import { authService } from './authService';
import { getServerURL } from './config';

const SERVER_URL = getServerURL();

const getMontageRequest = (montageType) => {
  if (montageType === 'booklet') {
    return { montageType: 'booklet', lane: 'booklet' };
  }
  if (montageType === 'pristol_express') {
    return { montageType: 'standard', lane: 'pristol_express' };
  }
  return { montageType: 'standard', lane: 'hard_cover' };
};

const request = async (path, options = {}) => {
  const response = await fetch(`${SERVER_URL}${path}`, {
    ...options,
    headers: authService.getAuthHeaders(),
  });
  const result = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(result.error || result.message || `Request failed with ${response.status}`);
  }
  return result.data;
};

const getFilename = (response, fallback) => {
  const disposition = response.headers?.get?.('content-disposition') || '';
  const encodedMatch = disposition.match(/filename\*=UTF-8''([^;]+)/i);
  if (encodedMatch) return decodeURIComponent(encodedMatch[1]);
  const filenameMatch = disposition.match(/filename="?([^";]+)"?/i);
  return filenameMatch?.[1] || fallback;
};

export const saveBlobDownload = (blob, filename) => {
  const blobUrl = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = blobUrl;
  link.download = filename;
  link.style.display = 'none';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.setTimeout(() => URL.revokeObjectURL(blobUrl), 1_000);
};

export const montageJobsService = {
  create(generationId, montageType) {
    const montageRequest = getMontageRequest(montageType);
    return request(`/generations/${encodeURIComponent(generationId)}/montage-jobs`, {
      method: 'POST',
      body: JSON.stringify({
        montage_type: montageRequest.montageType,
        lane: montageRequest.lane,
      }),
    }).then((submission) => submission?.result || submission);
  },

  get(generationId, montageType) {
    const { lane } = getMontageRequest(montageType);
    return request(
      `/generations/${encodeURIComponent(generationId)}/montage-jobs?lane=${lane}`
    );
  },

  async downloadArtifact(generationId, montageType, artifact = 'inner') {
    const { lane } = getMontageRequest(montageType);
    const response = await fetch(
      `${SERVER_URL}/generations/${encodeURIComponent(generationId)}`
        + `/montage-jobs/${encodeURIComponent(lane)}`
        + `/artifacts/${encodeURIComponent(artifact)}`,
      { headers: authService.getAuthHeaders() }
    );
    if (!response.ok) {
      const result = await response.json().catch(() => ({}));
      throw new Error(
        result.error || result.message || `Download failed with ${response.status}`
      );
    }
    return {
      blob: await response.blob(),
      filename: getFilename(
        response,
        `${generationId}_${lane}_${artifact}.pdf`
      ),
    };
  },
};
